module.exports = __webpack_public_path__ + "1ff25bbc3ddd9904850ddcbe435a9b61.svg";